export default __webpack_public_path__ + "static/The Home_Image 4_carousel 9@2x-1c7e3563256fd73b8bf0a5c06daafe6b.jpg";